/*LIBRARY*/
import { connect } from "react-redux";

/*COMPONENT*/
import LEFT_CONTENT from "./LEFT_CONTENT";

/*REDUX*/
import { set_value_properties } from "../../App/actions/propertiesActions";

/*PICTURE*/
import ICON_CLOSE_X_2 from "../../Assets/jsx/ICON_CLOSE_X_2";
import ICON_LAYER from "../../Assets/jsx/ICON_LAYER";

/*FUNCTION*/

/*DATA*/

/*CONST*/

const LEFT_CONTAINER = ({ properties, set_value_properties }) => {
  const { sidebar_left_status } = properties;

  const toggle_sidebar_left = () => {
    set_value_properties({
      key: "sidebar_left_status",
      value: !sidebar_left_status,
    });
  };

  return (
    <main>
      <section
        className="sidebar_left_map"
        style={{
          left: sidebar_left_status ? "5px" : "-320px",
          transition: "left 0.4s cubic-bezier(0.4, 0.0, 0.2, 1)",
        }}
      >
        <LEFT_CONTENT />
      </section>
      <button
        className="close_sidebar_left background_black outline_white"
        style={{
          left: sidebar_left_status ? "271px" : "15px",
          transition: "left 0.4s cubic-bezier(0.4, 0.0, 0.2, 1)",
        }}
        onClick={toggle_sidebar_left}
      >
        {sidebar_left_status ? (
          <ICON_CLOSE_X_2
            color="#fff"
            style={{
              width: "15px",
            }}
          />
        ) : (
          <ICON_LAYER
            color="#fff"
            style={{
              width: "15px",
            }}
          />
        )}
      </button>
    </main>
  );
};

const map_state_to_props = (state) => ({
  auth: state.auth,
  properties: state.properties,
});

export default connect(map_state_to_props, { set_value_properties })(
  LEFT_CONTAINER
);
